import { __assign } from '../../../node_modules/tslib/tslib.es6.js';
import CloseIcon from '@mui/icons-material/Close';
import { styled, Dialog, Slide, useMediaQuery, Fade, DialogTitle, Icon, DialogContent } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { brandclubStyles } from '../../../styles/index.js';
import { DIALOG_SCREEN_SIZE, TABLET_SCREEN_SIZE } from '../../../utils/constants/Constants.js';

var StyledDialog = styled(Dialog)(function (_a) {
    var _b;
    var theme = _a.theme;
    return ({
        '&.popup-drawer': (_b = {
                '& div.MuiDialog-paper': {
                    margin: 0,
                    borderRadius: 10,
                    minWidth: 569,
                    maxWidth: 569,
                    minHeight: 400,
                    color: theme.palette.primary.main,
                    boxShadow: 'none',
                },
                '& h2.MuiDialogTitle-root': {
                    padding: '12px 13px',
                },
                '& .close-icon': {
                    float: 'right',
                    display: 'flex',
                    width: 24,
                    height: 24,
                    color: theme.palette.primary.main,
                    cursor: 'pointer',
                    position: 'relative',
                    top: 7,
                    right: 7,
                },
                '& .dialog-content': __assign({ padding: 0, overflowY: 'auto', color: theme.palette.primary.main }, brandclubStyles.customScrollbar)
            },
            // media queries
            _b["@media screen and (max-width: ".concat(DIALOG_SCREEN_SIZE, "px)")] = {
                '& div.MuiDialog-paper': {
                    width: '100vw',
                    minWidth: '100vw',
                    maxWidth: '100vw',
                    maxHeight: '75vh',
                    position: 'absolute',
                    bottom: 0,
                },
            },
            _b),
    });
});
var SlideUpTransition = React.forwardRef(function Transition(props, ref) {
    return React.createElement(Slide, __assign({ direction: "up", ref: ref }, props));
});
/**
 * @returns dialog that turn into bottom drawer when viewport < TABLET_SCREEN_SIZE
 */
var PopupDrawer = function (_a) {
    var open = _a.open, onClose = _a.onClose, dialogProps = _a.dialogProps, children = _a.children;
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    var handleCloseDialog = function () { return onClose(); };
    return (React.createElement(StyledDialog, __assign({ open: open, className: "popup-drawer", BackdropProps: { style: { backgroundColor: brandclub_colors.darkBlue3 } }, onClose: handleCloseDialog, TransitionComponent: desktopView ? Fade : SlideUpTransition }, dialogProps),
        React.createElement(DialogTitle, null,
            React.createElement(Icon, { className: "close-icon", onClick: handleCloseDialog },
                React.createElement(CloseIcon, { sx: {
                        width: '100%',
                        height: '100%',
                    } }))),
        React.createElement(DialogContent, { className: "dialog-content" }, children)));
};

export { PopupDrawer };
//# sourceMappingURL=PopupDrawer.js.map
